import React from 'react';
import { CSVLink } from 'react-csv';

export default function CsvFile({ data, headers }) {
  const csvReport = {
    data,
    headers,
    filename: 'closed_positions.csv'
  };

  return <CSVLink {...csvReport}>Export to CSV</CSVLink>;
}
